export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}
export function dateFormat(row,column) {
    if(!row[column.property]) {
        return ''
    }
    const date = new Date(row[column.property])
    const yyyy = date.getFullYear()
    const MM = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    const dd = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    const hh = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    const mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    const ss = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    return yyyy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}